// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
body {
  overflow-y: scroll !important;
}

.psuedo-link {
  cursor: pointer;
}

.helper-text-wrapper {
  display: grid;
}

.helper-text-mobile {
  position: relative;
  top: 16%;
  left: 8%;
  pointer-events: none;
}

.helper-text-button, .helper-text-mobile {
  grid-area: 1/1;
}

i.fa.fa-question {
  color: #4330ff;
  font-size: 13px;
  position: absolute;
  pointer-events: fill;
}
i.fa.fa-question.question-larger {
  font-size: 20px;
}

@media screen and (min-device-width: 992px) {
  .logoImageWide {
    display: block;
  }
  .logoImageStacked {
    display: none;
  }
}
@media screen and (max-device-width: 991px) and (min-device-width: 768px) {
  .logoImageWide {
    display: none;
  }
  .logoImageStacked {
    display: block;
  }
}
@media screen and (max-device-width: 767px) {
  .logoImageWide {
    display: block;
  }
  .logoImageStacked {
    display: none;
  }
}
.virtual-portal-header {
  display: flex;
  flex: 1 1;
  width: 100%;
  background-color: #002869;
  min-height: 100px;
  align-items: start;
  box-shadow: 1px 5px 8px 0px #9c9898;
}
.virtual-portal-header .container {
  white-space: pre-wrap;
  grid-template-columns: 30% 50% 20%;
  grid-gap: 7px;
  display: grid;
  cursor: default;
  color: #ffffff;
  padding-top: 25px;
  position: relative;
}
.virtual-portal-header .container .logo img {
  margin: 10px 0 0;
  width: 179px;
  max-width: 179px;
  height: auto;
}
.virtual-portal-header .container .logo .logoImageStacked {
  height: 58px;
}
.virtual-portal-header .container .title .centered {
  margin: 0 0 0 0;
}
.virtual-portal-header .container .title .centered h4 {
  font-size: 24px;
}
.virtual-portal-header .container .title .centered h5 {
  font-weight: 100;
  font-size: 18px;
  margin-top: -5px;
}
.virtual-portal-header .container .info {
  display: inline-block;
  position: relative;
}
.virtual-portal-header .container .info a {
  float: right;
  background-color: #ffffff;
  padding: 1px 10px;
  border-radius: 50%;
  color: #002869;
  font-weight: 900;
  margin-right: 15px;
}
.virtual-portal-header .container .info a:hover {
  text-decoration: none;
  color: #002869;
  opacity: 0.8;
}
.virtual-portal-header .container .info .user-profile-image {
  max-height: 27px;
  max-width: 27px;
}
.virtual-portal-header .container .info .user-profile-image:hover {
  cursor: pointer;
}
.virtual-portal-header .container .info .menu {
  width: 236px;
  position: absolute;
  top: 75px;
  right: 0;
  background: #ffffff;
  color: #282829;
  z-index: 999;
  padding: 26px;
  box-shadow: 2px 5px 7px 0px #bfbdbd;
}
.virtual-portal-header .container .info .menu .menu-subheader {
  color: #c0c0c0;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0.88px;
  font-weight: 400;
}
.virtual-portal-header .container .info .menu .menu-name {
  white-space: pre-wrap;
  overflow-wrap: break-word;
}
.virtual-portal-header .container .info .menu .menu-title {
  white-space: pre;
  margin-bottom: 0;
}
.virtual-portal-header .container .info .menu .menu-title {
  color: #909092;
  font-size: 12px;
  line-height: 22px;
  letter-spacing: 0.88px;
  text-transform: uppercase;
}
.virtual-portal-header .container .info .menu hr {
  margin: 2rem 0;
}
.virtual-portal-header .container .info .menu ul, .virtual-portal-header .container .info .menu .menu-item {
  list-style-type: none;
  list-style-position: inside;
  margin: 0.5rem 0;
  letter-spacing: 0.88px;
  padding: 0;
  font-size: 14px;
}
.virtual-portal-header .container .info .menu ul a, .virtual-portal-header .container .info .menu .menu-item a {
  font-weight: 400;
  margin: 0;
  float: none;
  padding: 0;
  color: #606060;
}
.virtual-portal-header .container .info .menu .menu-item, .virtual-portal-header .container .info .menu a:hover {
  font-weight: 600;
  cursor: pointer;
  color: #002869;
}

.welcome {
  margin: 5px 0 30px;
}
.welcome h2 {
  color: #282829;
  font-size: 40px;
}
.welcome h5 {
  color: #606060;
  text-transform: none;
  letter-spacing: 0.88px;
  font-size: 14px;
}

.alert-section {
  height: auto;
}
.alert-section .header-alert {
  background: #DE0A01;
  color: #ffffff;
  width: auto;
  display: inline-block;
  padding: 10px 15px;
  margin-right: 10px;
  font-size: 1rem;
  border-radius: 0px 0px 3px 3px;
}
.alert-section .header-alert.gray {
  background: #606060;
}
.alert-section .header-alert:hover {
  text-decoration: none;
  cursor: pointer;
}
.alert-section .header-alert .fa {
  font-size: 36px;
  vertical-align: middle;
  padding: 0 0 1px 10px;
}

.emergency-broadcast-section {
  height: auto;
  width: 100%;
  max-width: none !important;
  box-shadow: 1px 5px 8px 0px #9c9898;
  margin-bottom: 5px;
}
.emergency-broadcast-section .header-emergency-broadcast {
  background: #fa504b;
  color: #ffffff;
  width: 100%;
  padding: 10px 15px;
  font-size: 1.2rem;
}
.emergency-broadcast-section .body-emergency-broadcast {
  font-size: 1rem;
}

.no-agenda {
  min-height: calc(100vh - 225px);
  padding-top: 50px;
}
.no-agenda h1, .no-agenda h4 {
  color: #2C2C2C;
}
.no-agenda h4 {
  font-weight: 600;
}
.no-agenda h5 {
  text-transform: uppercase;
  color: #606060;
  font-size: 14px;
  letter-spacing: 0.8px;
}
.no-agenda p {
  color: #606060;
  font-size: 18px;
  margin-top: 20px;
  font-weight: 100;
}
.no-agenda p a {
  text-decoration: underline;
}

.virtual-sessions-page .session-advisory {
  color: #606060;
}
.virtual-sessions-page button.filter-tabs {
  border: 2px solid #4330ff;
  min-width: 250px;
  cursor: pointer;
  border-radius: 3px;
  padding: 0;
}
.virtual-sessions-page button.filter-tabs .my-schedule, .virtual-sessions-page button.filter-tabs .agenda {
  font-size: 1rem;
  width: 50%;
  background: #ffffff;
  color: #4330ff;
  width: 50%;
  float: left;
  padding: 4px;
}
.virtual-sessions-page button.filter-tabs .my-schedule.active, .virtual-sessions-page button.filter-tabs .agenda.active {
  background: #4330ff;
  color: #ffffff;
}
.virtual-sessions-page button.filter-tabs:focus {
  outline-color: #4330ff;
}
.virtual-sessions-page .session-link {
  width: calc(100% - 100px);
}
.virtual-sessions-page .session-link:hover {
  text-decoration: none;
}
.virtual-sessions-page .session-icons {
  position: inherit;
  display: grid;
  max-height: 184px;
  right: 10px;
}
.virtual-sessions-page .session-icons button {
  vertical-align: middle;
  margin: auto;
  margin-right: 0px;
}
.virtual-sessions-page .session-icons .editp2plink {
  display: grid;
  text-decoration: none;
}
.virtual-sessions-page .session-icons .editp2p {
  border-radius: 5px;
  font-size: 14px;
  line-height: 1rem;
  padding: 10px 3px;
  border: 2px solid #fa504b;
  color: #fa504b;
  vertical-align: middle;
  background-color: transparent;
}
.virtual-sessions-page .session-icons .editp2p.btn-danger {
  color: #ffffff;
}
.virtual-sessions-page .session-icons .editp2p:hover {
  border-color: #fb736f;
  background-color: #fb736f;
  color: #ffffff;
}
.virtual-sessions-page .session-icons .editp2p:focus {
  outline: none;
  box-shadow: none;
}
.virtual-sessions-page .time-block-section {
  background: #eaeaea;
  margin: 30px 0;
  padding: 10px;
  font-size: 0.8rem;
  color: #002869;
  font-weight: 600;
  border-radius: 3px;
}
.virtual-sessions-page .time-block-section p.formatted-time {
  margin: 20px 0;
  font-weight: 700;
  font-size: 14px;
  text-transform: uppercase;
}
.virtual-sessions-page .day-break {
  border-top: 2px dashed #909092;
}
.virtual-sessions-page .session {
  grid-template-columns: 17% 68% 15%;
  display: grid;
  background: #ffffff;
  color: #282829;
  border: 0.5px solid #eaeaea;
  line-height: 10px;
  text-decoration: none;
  position: relative;
  box-shadow: 2px 2px 7px 0px #bfbdbd;
  margin: 20px 0;
  min-height: 200px;
  border-radius: 3px;
}
.virtual-sessions-page .session.itinerary {
  padding: 0 15px;
  grid-template-columns: 100%;
  min-height: 0;
  text-indent: 20px;
}
.virtual-sessions-page .session.itinerary p {
  margin: 10px;
  text-transform: uppercase;
  font-style: italic;
  font-weight: 400;
  font-size: 14px;
}
.virtual-sessions-page .session.session-over .container {
  opacity: 0.6;
}
.virtual-sessions-page .session.session-over .container p, .virtual-sessions-page .session.session-over .container h3 {
  color: #6D6E71;
}
.virtual-sessions-page .session.session-over .session-cta-wrapper {
  box-shadow: inset 0 0 0 100vw rgba(239, 239, 240, 0.78);
}
.virtual-sessions-page .session.session-over .session-cta-wrapper .registration-button {
  font-size: 1.25rem;
  border-radius: 50%;
  width: 55px;
  height: 55px;
}
.virtual-sessions-page .session .session-cta-wrapper {
  background-size: cover;
  display: flex;
  max-height: 198px;
}
.virtual-sessions-page .session .session-cta-wrapper .registration-button {
  margin: auto;
  background: #1f96ff;
  border-radius: 35px;
  color: #002869;
  border: none;
  font-weight: 600;
  text-align: left;
  font-size: 0.88rem;
  padding: 10px;
  width: 75%;
  height: 60px;
  text-align: center;
  line-height: 15px;
}
.virtual-sessions-page .session .session-cta-wrapper .registration-button.registered {
  background: #B8DEFF;
  color: #002869;
}
.virtual-sessions-page .session .session-cta-wrapper .registration-button.p2pSession {
  background: #eaeaea;
  color: #606060;
}
.virtual-sessions-page .session .session-cta-wrapper .registration-button .icon-and-text {
  position: relative;
  padding-left: 30px;
}
.virtual-sessions-page .session .session-cta-wrapper .registration-button .icon-and-text i {
  position: absolute;
  font-size: 1.5rem;
  left: 10px;
  top: 3px;
}
.virtual-sessions-page .session .session-cta-wrapper .registration-button .icon-and-text i.fa-minus {
  top: -4px;
}
.virtual-sessions-page .session .session-cta-wrapper .registration-button:focus {
  outline: 0;
}
.virtual-sessions-page .session .session-cta-wrapper.not-authorized {
  box-shadow: inset 0 0 0 100vw rgba(239, 239, 240, 0.75);
}
.virtual-sessions-page .session .session-cta-wrapper.not-authorized .registration-button {
  color: #606060;
}
.virtual-sessions-page .session .container {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  padding: 15px 35px;
  margin-top: -10px;
}
.virtual-sessions-page .session .container .inner-wrapper {
  margin: auto;
  width: 100%;
}
.virtual-sessions-page .session .container .action-links {
  color: #606060;
  margin-top: 10px;
  width: 100%;
}
.virtual-sessions-page .session .container .action-links .more, .virtual-sessions-page .session .container .action-links .add-to-calendar {
  width: 50%;
  font-size: 14px;
}
.virtual-sessions-page .session .container .action-links .more:hover, .virtual-sessions-page .session .container .action-links .add-to-calendar:hover {
  cursor: pointer;
}
.virtual-sessions-page .session .container .action-links .add-to-calendar, .virtual-sessions-page .session .container .action-links .more {
  color: #6D6E71;
}
.virtual-sessions-page .session .container .action-links .add-to-calendar:hover, .virtual-sessions-page .session .container .action-links .more:hover {
  text-decoration: none;
}
.virtual-sessions-page .session .container .action-links .add-to-calendar {
  margin-left: 45px;
}
.virtual-sessions-page .session .container .action-links .fa {
  margin-right: 10px;
}
.virtual-sessions-page .session .session-time {
  background: #909092;
  color: white;
  padding: 10px;
}
.virtual-sessions-page .session .session-header .session-type {
  text-transform: uppercase;
  color: #282829;
  margin: 8px 0px;
  font-size: 14px;
  font-weight: 600;
}
.virtual-sessions-page .session .session-header .session-name {
  padding-top: 10px;
  color: #282829;
  display: block;
  display: -webkit-box;
  max-width: 100%;
  margin: -15px auto 10px;
  -webkit-line-clamp: 2;
  /* autoprefixer: off */
  -webkit-box-orient: vertical;
  /* autoprefixer: on */
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 26px;
  font-weight: 600;
}
.virtual-sessions-page .session .session-header .session-name.open-true {
  -webkit-line-clamp: 3;
}
.virtual-sessions-page .session .session-information.hidden {
  display: none;
}
.virtual-sessions-page .session .session-information {
  max-width: 900px;
  padding-top: 10px;
  color: #282829;
  line-height: 1em;
}
.virtual-sessions-page .session .session-information .session-body p, .virtual-sessions-page .session .session-information .session-body li {
  color: #606060;
  font-size: 17px;
  line-height: 20px;
  font-weight: 400;
}
.virtual-sessions-page .session .session-information .session-body ul {
  list-style-type: none;
}
.virtual-sessions-page .session .session-information .session-body ul > li:before {
  content: "–";
  position: absolute;
  margin-left: -1em;
}
.virtual-sessions-page .session .user-list.speaker {
  color: #282829;
  margin: 10px 0;
  text-transform: none;
}
.virtual-sessions-page .session .user-list.speaker img {
  max-width: 65px;
  height: auto;
}
.virtual-sessions-page .session .user-list.speaker .user-info {
  font-weight: 100;
  font-size: 1.2rem;
  color: #606060;
  line-height: 15px;
}
.virtual-sessions-page .session .user-list.speaker .user-info .full-name {
  font-weight: 600;
}
.virtual-sessions-page .session .user-list.speaker .user-info .speaker-type {
  text-transform: uppercase;
  font-size: 0.75rem;
  font-weight: 400;
  color: #000000;
  margin-top: 9px;
}
.virtual-sessions-page .session .user-list.speaker .user-info div {
  margin: 0px 0px 5px;
}
.virtual-sessions-page .btn.btn-danger {
  background-color: #fa504b;
}
.virtual-sessions-page .btn.btn-danger:disabled, .virtual-sessions-page .btn.btn-danger.disabled {
  background-color: #606060;
  border-color: #606060;
}
.virtual-sessions-page .btn.btn-danger:disabled:hover, .virtual-sessions-page .btn.btn-danger.disabled:hover {
  background-color: #606060;
  border-color: #606060;
  cursor: not-allowed;
}
.virtual-sessions-page .btn.btn-danger:hover {
  background-color: #fb736f;
  border-color: #fb736f;
}
.virtual-sessions-page .btn.btn-danger.closing-details {
  margin: auto;
  display: block;
  margin-bottom: 50px;
}

.header-router-footer {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.header-router {
  flex: 1 1;
}

.session-closing-details .pseudo-link {
  color: #006AC7;
  cursor: pointer;
  text-decoration: underline;
}

footer.virtual-footer {
  flex-shrink: 0;
  background: #002869;
  color: #ffffff;
  padding: 15px 0;
}
footer.virtual-footer .session-closing-details {
  margin-top: 25px;
}
footer.virtual-footer .session-closing-details p {
  font-weight: 100;
  font-size: 26px;
}
footer.virtual-footer .session-closing-details p strong {
  font-weight: 600;
}
footer.virtual-footer .session-closing-details .pseudo-link {
  cursor: pointer;
  text-decoration: underline;
  color: #006AC7;
}
footer.virtual-footer .copyright {
  display: block;
  text-align: center;
  font-size: 14px;
  font-style: italic;
  margin: 25px auto;
}
footer.virtual-footer .copyright a {
  color: #ffffff;
}

.react-modal.error-modal, .react-modal.info-modal, .react-modal.evaluation-modal {
  padding: 45px;
  min-height: 500px;
  background-color: #ffffff;
}
.react-modal.error-modal .button-container button, .react-modal.info-modal .button-container button, .react-modal.evaluation-modal .button-container button {
  margin-top: 40px;
}
.react-modal.error-modal .pm-info > p, .react-modal.info-modal .pm-info > p, .react-modal.evaluation-modal .pm-info > p {
  margin: 0;
}
.react-modal.error-modal .live-chat-link, .react-modal.info-modal .live-chat-link, .react-modal.evaluation-modal .live-chat-link {
  color: #4330ff;
  font-weight: 600;
  cursor: pointer;
}
.react-modal.error-modal.confirm .generic-info-modal-content p, .react-modal.info-modal.confirm .generic-info-modal-content p, .react-modal.evaluation-modal.confirm .generic-info-modal-content p {
  text-align: center;
}
.react-modal.error-modal.confirm, .react-modal.info-modal.confirm, .react-modal.evaluation-modal.confirm {
  min-height: 275px;
}
.react-modal.error-modal.confirm .button-container, .react-modal.info-modal.confirm .button-container, .react-modal.evaluation-modal.confirm .button-container {
  display: flex;
}
.react-modal.error-modal .modalCancelText, .react-modal.info-modal .modalCancelText, .react-modal.evaluation-modal .modalCancelText {
  text-align: center;
  cursor: pointer;
  text-decoration: underline;
  color: #4330ff;
  font-size: 24px;
}

.react-modal.evaluation-modal .header h3 {
  margin-bottom: 20px;
}
.react-modal.evaluation-modal .header .fa-times-thin {
  position: absolute;
  right: 15px;
  top: 10px;
}
.react-modal.evaluation-modal .evaluation-modal-content {
  margin-top: 2rem;
}
.react-modal.evaluation-modal .evaluation-modal-content .evaluation-modal-stars {
  text-align: center;
  margin: 0 3.5rem 1rem;
  display: flex;
  justify-content: space-between;
}
.react-modal.evaluation-modal .evaluation-modal-content .evaluation-modal-stars .fa.fa-star-o.unchecked {
  color: #4330ff;
}
.react-modal.evaluation-modal .evaluation-modal-content textarea.form-control {
  min-height: 90px;
  resize: none;
}
.react-modal.evaluation-modal .evaluation-modal-content textarea.form-control:focus {
  border: none;
  outline: none;
  box-shadow: none;
}
.react-modal.evaluation-modal .evaluation-modal-content ::placeholder {
  color: #c0c0c0;
}
.react-modal.evaluation-modal .evaluation-modal-content .button-container {
  text-align: center;
}

.follow-up {
  padding-top: 10px;
  margin-right: 5px;
}
.follow-up .follow-up-label {
  padding-right: 20px;
}
.follow-up input {
  margin-right: 5px;
}

.react-modal.generic.info-modal .generic-info-modal-header .fa-times-thin {
  position: absolute;
  right: 15px;
  top: 10px;
}
.react-modal.generic.info-modal h4 {
  font-weight: 600;
  margin: 0 0 22px;
  color: #2C2C2C;
}
.react-modal.generic.info-modal .fa {
  margin-right: 10px;
}
.react-modal.generic.info-modal a {
  color: #006AC7;
  font-weight: 600;
  cursor: pointer;
}
.react-modal.generic.info-modal .eblue-button a {
  color: #ffffff;
  font-weight: 400;
}
.react-modal.generic.info-modal .button-container hr {
  margin-top: 45px;
}
.react-modal.generic.info-modal .take-event-eval {
  font-weight: 400;
}

.react-modal.info-pop-up {
  height: 90%;
}

.react-modal.double-booking, .react-modal.troubleshooting {
  height: 70%;
}

.react-modal.wishlist-user-info .generic-info-modal-content .user-list {
  color: #282829;
  margin: 10px 0;
  text-transform: none;
}
.react-modal.wishlist-user-info .generic-info-modal-content .user-list img {
  width: 110px;
  height: auto;
}
.react-modal.wishlist-user-info .generic-info-modal-content .user-list .user-info {
  font-weight: 400;
  font-size: 1.2rem;
  color: #606060;
  line-height: 20px;
  padding: 20px 0 0 10px;
}
.react-modal.wishlist-user-info .generic-info-modal-content .user-list .user-info .full-name {
  color: #282829;
  font-weight: 800;
}
.react-modal.wishlist-user-info .generic-info-modal-content .user-list .user-info div {
  margin: 0px 0px 5px;
}
.react-modal.wishlist-user-info .generic-info-modal-content .bio {
  padding-top: 20px;
  color: #606060;
}
.react-modal.wishlist-user-info .generic-info-modal-content .bio p {
  margin: 0;
}

.react-modal.error-modal .generic-error-modal-header .fa-times-thin {
  position: absolute;
  right: 15px;
  top: 10px;
}

.closing-details .see-you-soon {
  color: #6D6E71;
  margin: 30px 0 0;
}
.closing-details .thank-you-body-content {
  color: #606060;
}
.closing-details .thank-you-body-content h6 {
  font-weight: 600;
}
.closing-details .thank-you-body-content p {
  font-weight: 300;
}
.closing-details .take-event-eval {
  display: block;
  margin: 25px 0;
}
.closing-details .take-event-eval .fa {
  font-weight: 600;
  font-size: 18px;
}
.closing-details button:hover, .closing-details a:hover {
  text-decoration: none;
}
.closing-details .upcoming-event-row {
  box-shadow: 2px 2px 7px 0px #bfbdbd;
  margin: 15px 0;
  border-radius: 3px;
}
.closing-details .upcoming-event-row .container {
  padding: 0;
  display: grid;
  grid-template-columns: 20% 55% 25%;
}
.closing-details .upcoming-event-row .container .event-image {
  background-position: center;
  background-size: cover;
}
.closing-details .upcoming-event-row .container .main-content {
  padding: 10px;
}
.closing-details .upcoming-event-row .container .main-content .event-date {
  text-transform: uppercase;
}
.closing-details .upcoming-event-row .container .main-content h5 {
  font-size: 14px;
  font-weight: 600;
}
.closing-details .upcoming-event-row .container .main-content h6 {
  font-size: 12px;
}
.closing-details .upcoming-event-row .container .main-content .learn-more {
  font-size: 12px;
  font-weight: 500;
}
.closing-details .upcoming-event-row .container .main-content .learn-more:hover {
  text-decoration: none;
}
.closing-details .upcoming-event-row .container .register-button-container {
  display: grid;
}
.closing-details .upcoming-event-row .container .register-button-container button.btn.btn-danger {
  background-color: #fa504b;
  border-color: #fa504b;
  vertical-align: middle;
  margin: auto;
  margin-right: 10px;
  padding: 0;
}
.closing-details .upcoming-event-row .container .register-button-container button.btn.btn-danger.registered {
  border-color: #606060;
  background-color: #606060;
}
.closing-details .upcoming-event-row .container .register-button-container button.btn.btn-danger.registered a {
  cursor: not-allowed;
}
.closing-details .upcoming-event-row .container .register-button-container button.btn.btn-danger.registered a .fa {
  margin: 1px;
}
.closing-details .upcoming-event-row .container .register-button-container button.btn.btn-danger.registered:hover {
  border-color: #606060;
  background-color: #606060;
}
.closing-details .upcoming-event-row .container .register-button-container button.btn.btn-danger a {
  font-size: 11px;
  color: #ffffff;
  display: block;
  padding: 6px 12px 6px;
  font-weight: 400;
  letter-spacing: 0.5px;
}
.closing-details .upcoming-event-row .container .register-button-container button.btn.btn-danger a:hover {
  text-decoration: none;
}
.closing-details .upcoming-event-row .container .register-button-container button.btn.btn-danger:hover {
  border-color: #fb736f;
  background-color: #fb736f;
}

.btn-danger:hover {
  background-color: #fb736f;
  border-color: #fb736f;
}
.btn-danger:focus {
  outline: none !important;
  box-shadow: none !important;
}

.btn-danger-tertiary {
  background-color: #DE0A01 !important;
  border-color: #DE0A01 !important;
  color: #ffffff !important;
}
.btn-danger-tertiary:hover {
  background-color: rgb(181.3829596413, 8.1704035874, 0.8170403587) !important;
  border-color: rgb(181.3829596413, 8.1704035874, 0.8170403587) !important;
}
.btn-danger-tertiary:focus {
  outline: none !important;
  box-shadow: none !important;
}

.btn-primary {
  background-color: #006AC7 !important;
  border-color: #006AC7 !important;
  border: 2px solid #006AC7 !important;
  color: #ffffff !important;
}
.btn-primary.cancel {
  background-color: #ffffff !important;
  color: #006AC7 !important;
}
.btn-primary.cancel:hover {
  background-color: #ffffff !important;
  color: #264A82 !important;
  border-color: #264A82 !important;
}
.btn-primary:disabled {
  opacity: 1 !important;
  background-color: #E1E8F4 !important;
  border-color: #E1E8F4 !important;
  color: #002869 !important;
}
.btn-primary:disabled:hover {
  opacity: 1 !important;
  background-color: #E1E8F4 !important;
  border-color: #E1E8F4 !important;
  cursor: not-allowed;
}
.btn-primary:hover {
  background-color: #011D4B !important;
  border-color: #011D4B !important;
  color: #ffffff !important;
}
.btn-primary:focus {
  outline: none !important;
  box-shadow: none !important;
}
.btn-primary:active {
  background-color: #011D4B !important;
  border-color: #011D4B !important;
}

.eblue-button {
  background-color: #006AC7;
  color: #ffffff;
  border: 2px solid #006AC7;
  border-radius: 5px;
  font-size: 14px;
  padding: 10px 15px;
  letter-spacing: 1.5px;
  white-space: nowrap;
}
.eblue-button:disabled {
  opacity: 0.6;
  background-color: #ffffff;
  border: 2px solid #264A82;
  color: #264A82;
  font-weight: 400;
}
.eblue-button:disabled:hover {
  border: 2px solid #264A82;
  background-color: inherit;
  cursor: not-allowed;
}
.eblue-button:active {
  background-color: #ffffff;
  color: #006AC7;
}
.eblue-button:hover {
  background-color: #264A82;
  border-color: #264A82;
  cursor: pointer;
}
.eblue-button:focus {
  outline: none;
}
.eblue-button.open-chat-window {
  margin: auto;
  display: block;
  padding: 4px 6px;
  font-size: 1rem;
  letter-spacing: inherit;
}
.eblue-button.give-feedback {
  background-color: #006AC7;
  border-color: #006AC7;
}
.eblue-button.give-feedback:hover {
  background-color: #264A82;
  border-color: #264A82;
}
.eblue-button.feedback-given {
  background-color: #264A82;
  border-color: #264A82;
  color: #ffffff;
}
.eblue-button.feedback-given:disabled {
  background-color: #264A82;
  border-color: #264A82;
  color: #ffffff;
  opacity: 1;
}

.center-progress-display i.fa-spinner {
  color: #6D6E71;
}

.fa-times-thin:before {
  content: "×";
  color: #6D6E71;
}

hr {
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  margin: 0 0 22px;
  color: #6D6E71;
}

@media only screen and (max-width: 1200px) {
  .virtual-sessions-page .session {
    grid-template-columns: 20% 60% 20%;
  }
  .virtual-sessions-page .session-timeslots {
    grid-template-columns: 20% 60% 20%;
  }
}
@media only screen and (max-width: 992px) {
  .welcome h2 {
    font-size: 42px;
  }
  .welcome h5 {
    font-size: 12px;
  }
  .virtual-sessions-page .session {
    grid-template-columns: 25% 50% 25%;
  }
  .virtual-sessions-page .session .session-header .session-name {
    font-size: 24px;
  }
  .virtual-sessions-page .session .session-header .session-type {
    font-size: 12px;
  }
  .virtual-sessions-page .session .session-icons {
    right: 0;
  }
  .virtual-sessions-page .session-timeslots {
    grid-template-columns: 25% 50% 25%;
  }
}
@media only screen and (max-width: 767px) {
  .virtual-portal-header {
    display: inline-block;
  }
  .virtual-portal-header .container {
    display: block;
    position: relative;
    padding-top: 5px;
  }
  .virtual-portal-header .container .logo {
    width: 50%;
    float: left;
    margin-bottom: 10px;
  }
  .virtual-portal-header .container .logo img {
    max-width: 128px;
  }
  .virtual-portal-header .container .title {
    width: 100%;
    float: left;
    margin-left: 3px;
  }
  .virtual-portal-header .container .title .centered h4 {
    font-size: 22px;
  }
  .virtual-portal-header .container .title .centered h5 {
    font-size: 14px;
  }
  .virtual-portal-header .container .info {
    position: absolute;
    right: 10px;
    top: 15px;
    display: flex;
    flex-direction: row-reverse;
  }
  .virtual-portal-header .container .info .menu {
    top: 93px;
  }
  .alert-section .header-alert {
    font-size: 0.8rem;
  }
  .alert-section .header-alert .fa {
    font-size: 1.5rem;
    padding: 0px 0px 0px 5px;
    line-height: 5px;
  }
  .filter-tabs {
    width: 95%;
    margin: auto;
    display: block;
  }
  .welcome {
    margin: 20px auto;
    width: 95%;
    display: block;
  }
  .welcome h2 {
    font-size: 32px;
  }
  .virtual-sessions-page .time-block-section p.formatted-time {
    font-weight: 600;
  }
  .virtual-sessions-page .session {
    display: inherit;
  }
  .virtual-sessions-page .session .session-cta-wrapper {
    min-height: 115px;
  }
  .virtual-sessions-page .session .session-cta-wrapper .registration-button {
    margin-left: 3%;
    font-size: 0.75rem;
    font-weight: 400;
    max-width: 40%;
    max-height: 50px;
  }
  .virtual-sessions-page .session .container {
    padding: 15px 10px;
  }
  .virtual-sessions-page .session .container .action-links .add-to-calendar {
    margin-left: none;
  }
  .virtual-sessions-page .session .container .action-links .add-to-calendar, .virtual-sessions-page .session .container .action-links .more {
    float: left;
    margin: auto;
    font-size: 14px;
  }
  .virtual-sessions-page .session .container .session-header .session-name {
    font-size: 20px;
  }
  .virtual-sessions-page .session .container .session-header .session-type {
    font-size: 12px;
  }
  .virtual-sessions-page .session .session-icons {
    margin: 10px 0;
  }
  .virtual-sessions-page .session .session-icons button {
    margin-right: auto;
  }
  .virtual-sessions-page .session .session-icons .eblue-button {
    font-size: 0.8rem;
  }
  .virtual-sessions-page .session.itinerary p {
    margin-left: 0px;
    text-indent: 10px;
  }
  .virtual-sessions-page .session .session-information {
    line-height: 0.75em;
  }
  .virtual-sessions-page .session .session-information .session-body p, .virtual-sessions-page .session .session-information .session-body li {
    font-size: 14px;
    line-height: 18px;
    font-weight: 400;
  }
  .virtual-sessions-page .session .session-information .session-body ul > li:before {
    margin-left: -0.75em;
  }
  .virtual-sessions-page .session-timeslots {
    grid-template-columns: unset;
    height: auto;
    text-align: center;
  }
  .virtual-sessions-page .session-timeslots .timeslot-btn-div {
    margin: 15px;
  }
  .virtual-sessions-page .session-timeslots .add-to-calendar {
    display: block;
    width: 100%;
    text-align: center;
    margin: 15px 0;
  }
  footer.virtual-footer p {
    font-size: 20px;
  }
  footer.virtual-footer .pseudo-link {
    cursor: pointer;
    text-decoration: underline;
  }
  footer.virtual-footer .copyright {
    font-size: 10px;
  }
  .closing-details .event-eval-btn {
    margin-top: 10px;
  }
  .closing-details .upcoming-event-row .container .event-image {
    display: none;
  }
  .closing-details .upcoming-event-row .container {
    grid-template-columns: inherit;
  }
  .closing-details .upcoming-event-row .container .register-button-container button.btn.btn-danger {
    margin: auto;
    margin-bottom: 10px;
  }
}
.bad-token input {
  width: 75%;
  margin-bottom: 10px;
}

/* ZOOM CSS */
#zmmtg-root {
  display: none;
}

#wc-content {
  height: calc(100% - 122px) !important;
  bottom: -118px;
}

#wc-container-right {
  height: calc(100vh - 153px) !important;
}

.ReactVirtualized__Grid.ReactVirtualized__List.chat-virtualized-list {
  max-height: calc(100vh - 285px) !important;
}

.ReactVirtualized__Grid__innerScrollContainer {
  max-height: calc(100vh - 320px) !important;
  overflow-y: scroll !important;
}

.active-video-container__wrap {
  height: calc(100vh - 200px);
}

.audio-option-menu,
.video-option-menu {
  display: none !important;
}

.footer-button__button-label {
  color: white;
}

#moreButton {
  display: none;
}

.send-video-container button,
.join-audio-container button {
  color: #ffffff;
}

.session-timeslots {
  color: #909092;
  font-size: 12px;
  border-top: 1px dashed #909092;
  padding: 12px;
  width: 100%;
  display: grid;
  grid-template-columns: 20% 65% 15%;
  position: relative;
  top: -26px;
  background: #ffffff;
  box-shadow: 2px 2px 8px 0px #bfbdbd;
  height: 6rem;
}
.session-timeslots .full-name {
  font-weight: 900;
  font-size: 13px;
}
.session-timeslots .btn-cancel {
  border: 1px solid #909092;
}
.session-timeslots .timeslot-btn-div {
  display: grid;
}
.session-timeslots .timeslot-btn {
  align-self: center;
  padding: 5px 15px;
  margin: 0 10px;
  font-size: 14px;
}
.session-timeslots .timeslot-btn.btn-cancel {
  border: 2px solid #fa504b;
  padding: 5px 30px;
  color: #fa504b;
}
.session-timeslots .timeslot-btn.btn-cancel:hover {
  border-color: #fb736f;
  background-color: #fb736f;
  color: #ffffff;
}
.session-timeslots .timeslot-btn.btn-danger {
  color: #ffffff;
}
.session-timeslots .add-to-calendar {
  width: 50%;
  font-size: 14px;
  color: #6D6E71;
}
.session-timeslots .add-to-calendar:hover {
  cursor: pointer;
  text-decoration: none;
}
.session-timeslots .add-to-calendar .fa {
  margin-right: 10px;
}

.wizard-links {
  margin-bottom: 20px;
  width: 100%;
  float: left;
}
.wizard-links .link-divider {
  color: #006AC7;
  font-weight: 100;
  line-height: 5px;
  position: relative;
  top: -3px;
  float: left;
  border-left: 2px solid #006AC7;
  width: 2px;
  height: 41px;
  display: block;
  margin: 0 12px;
}
.wizard-links .profile-nav {
  float: left;
}
.wizard-links .profile-nav .active {
  position: relative;
}
.wizard-links .profile-nav a:hover {
  text-decoration: none;
}
.wizard-links .wizard-nav {
  display: grid;
  grid-template-columns: 2fr 2fr 2fr;
  border: 2px solid #006AC7;
  border-radius: 3px;
  float: left;
  color: #006AC7;
}
.wizard-links .wizard-nav a, .wizard-links .wizard-nav div {
  text-align: center;
  white-space: pre;
  padding: 3px 15px;
}
.wizard-links a {
  color: #909092;
}
.wizard-links a.my-details {
  border: 2px solid #006AC7;
  color: #006AC7;
  background: #ffffff;
  padding: 3px 15px;
  border-radius: 3px;
  float: left;
}
.wizard-links a.my-details.active {
  background-color: #006AC7;
  color: #ffffff;
}
.wizard-links .active {
  background-color: #006AC7;
  color: #ffffff;
}

.wizard-form {
  margin-top: 10px;
}
.wizard-form input, .wizard-form textarea {
  width: 100%;
  border: 1px #909092 solid;
  border-radius: 3px;
  color: #606060;
}
.wizard-form h4 {
  color: #2C2C2C;
}
.wizard-form p {
  color: #6D6E71;
}
.wizard-form .bottom-buttons {
  text-align: center;
}
.wizard-form .rounded-circle {
  margin-right: 5px;
}
.wizard-form .submit {
  color: #ffffff;
  background-color: #006AC7;
  width: 200px;
  border: 2px solid #006AC7;
}
.wizard-form .submit:hover {
  background-color: #011D4B !important;
  border-color: #011D4B !important;
}
.wizard-form .submit:disabled {
  background-color: #eaeaea;
  background-color: #eaeaea;
}
.wizard-form .submit:disabled i {
  margin-right: 10px;
}
.wizard-form .submit:focus {
  outline: none;
}
.wizard-form .submit.previous {
  color: #006AC7;
  background: #ffffff;
  border: 2px solid #006AC7;
}
.wizard-form .submit.previous:hover {
  color: #011D4B;
  background: #E0F1FF !important;
  border-color: #011D4B;
}
.wizard-form .lps {
  width: 345px;
}
.wizard-form label {
  color: #909092;
  font-weight: normal;
  display: block;
  margin-bottom: 0;
}

@media only screen and (max-width: 585px) {
  .wizard-links .link-divider {
    display: none;
  }
  .wizard-links .wizard-nav {
    display: block;
    margin-top: 10px;
  }
  .wizard-links a.my-details, .wizard-links .profile-nav {
    float: none;
  }
  .wishlist-rank-page .wishlistDraggable {
    text-align: center;
    display: block;
  }
  .wishlist-rank-page .wishlistDraggable .action-button {
    margin-top: 5px;
  }
  .react-modal.error-modal, .react-modal.info-modal, .react-modal.evaluation-modal {
    min-height: 300px;
  }
  .react-modal.error-modal .button-container button, .react-modal.info-modal .button-container button, .react-modal.evaluation-modal .button-container button {
    margin-top: 0px;
  }
}
@media only screen and (max-width: 992px) {
  .wizard-links a.my-details, .wizard-links .wizard-nav a, .wizard-links .wizard-nav div {
    padding: 3px;
    font-size: 12px;
  }
  .wizard-links .link-divider {
    height: 36px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/VirtualPortal/css/sessions.scss","webpack://./src/app/variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,6BAAA;AACF;;AACA;EACE,eAAA;AAEF;;AACA;EACE,aAAA;AAEF;;AACA;EACE,kBAAA;EACA,QAAA;EACA,QAAA;EACA,oBAAA;AAEF;;AACA;EACE,cAAA;AAEF;;AACA;EACE,cCEY;EDDZ,eAAA;EACA,kBAAA;EACA,oBAAA;AAEF;AADE;EACE,eAAA;AAGJ;;AACA;EACE;IACE,cAAA;EAEF;EAAA;IACE,aAAA;EAEF;AACF;AACA;EACE;IACE,aAAA;EACF;EACA;IACE,cAAA;EACF;AACF;AAEA;EACE;IACE,cAAA;EAAF;EAEA;IACE,aAAA;EAAF;AACF;AAIA;EACE,aAAA;EACA,SAAA;EACA,WAAA;EACA,yBCrCa;EDsCb,iBAAA;EACA,kBAAA;EACA,mCAAA;AAFF;AAGE;EACE,qBAAA;EACA,kCAAA;EACA,aAAA;EACA,aAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AADJ;AAEI;EACE,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;AAAN;AAEI;EACE,YAAA;AAAN;AAGM;EACE,eAAA;AADR;AAEQ;EACE,eAAA;AAAV;AAEQ;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;AAAV;AAII;EACE,qBAAA;EACA,kBAAA;AAFN;AAGM;EACE,YAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cChFO;EDiFP,gBAAA;EACA,kBAAA;AADR;AAEQ;EACE,qBAAA;EACA,cCrFK;EDsFL,YAAA;AAAV;AAGM;EACE,gBAAA;EACA,eAAA;AADR;AAEQ;EACE,eAAA;AAAV;AAGM;EACE,YAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,mBAAA;EACA,cC1GC;ED2GD,YAAA;EACA,aAAA;EACA,mCAAA;AADR;AAEQ;EACE,cC1HI;ED2HJ,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;AAAV;AAEQ;EACE,qBAAA;EACA,yBAAA;AAAV;AAEQ;EACE,gBAAA;EACA,gBAAA;AAAV;AAEQ;EACE,cC1IU;ED2IV,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;AAAV;AAEQ;EACE,cAAA;AAAV;AAEQ;EACE,qBAAA;EACA,2BAAA;EACA,gBAAA;EACA,sBAAA;EACA,UAAA;EACA,eAAA;AAAV;AACU;EACE,gBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,cC7JO;AD8JnB;AAEQ;EACE,gBAAA;EACA,eAAA;EACA,cCrJK;ADqJf;;AAQA;EACE,kBAAA;AALF;AAME;EACE,cCpKK;EDqKL,eAAA;AAJJ;AAME;EACE,cClLe;EDmLf,oBAAA;EACA,sBAAA;EACA,eAAA;AAJJ;;AAQA;EACE,YAAA;AALF;AAME;EACE,mBC1Ka;ED2Kb,cAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,8BAAA;AAJJ;AAKI;EACE,mBCrMa;ADkMnB;AAKI;EACE,qBAAA;EACA,eAAA;AAHN;AAKI;EACE,eAAA;EACA,sBAAA;EACA,qBAAA;AAHN;;AAQA;EACE,YAAA;EACA,WAAA;EACA,0BAAA;EACA,mCAAA;EACA,kBAAA;AALF;AAME;EACE,mBC1MI;ED2MJ,cAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;AAJJ;AAME;EACE,eAAA;AAJJ;;AAQA;EACE,+BAAA;EACA,iBAAA;AALF;AAME;EACE,cC5KO;ADwKX;AAME;EACE,gBAAA;AAJJ;AAME;EACE,yBAAA;EACA,cChPe;EDiPf,eAAA;EACA,qBAAA;AAJJ;AAME;EACE,cCrPe;EDsPf,eAAA;EACA,gBAAA;EACA,gBAAA;AAJJ;AAKI;EACE,0BAAA;AAHN;;AASE;EACE,cCjQe;AD2PnB;AAQE;EACE,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;AANJ;AAOI;EACE,eAAA;EACA,UAAA;EACA,mBAAA;EACA,cCjQQ;EDkQR,UAAA;EACA,WAAA;EACA,YAAA;AALN;AAMM;EACE,mBCtQM;EDuQN,cAAA;AAJR;AAOI;EACE,sBC3QQ;ADsQd;AAQE;EACE,yBAAA;AANJ;AAOI;EACE,qBAAA;AALN;AAQE;EACE,iBAAA;EACA,aAAA;EACA,iBAAA;EACA,WAAA;AANJ;AAOI;EACE,sBAAA;EACA,YAAA;EACA,iBAAA;AALN;AAOI;EACE,aAAA;EACA,qBAAA;AALN;AAOI;EACE,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,yBAAA;EACA,cCpSE;EDqSF,sBAAA;EACA,6BAAA;AALN;AAMM;EACE,cAAA;AAJR;AAMM;EACE,qBC1SU;ED2SV,yBC3SU;ED4SV,cAAA;AAJR;AAMM;EACE,aAAA;EACA,gBAAA;AAJR;AAQE;EACE,mBC1US;ED2UT,cAAA;EACA,aAAA;EACA,iBAAA;EACA,cC5TW;ED6TX,gBAAA;EACA,kBAAA;AANJ;AAOI;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AALN;AAQE;EACE,8BAAA;AANJ;AAQE;EACE,kCAAA;EACA,aAAA;EACA,mBAAA;EACA,cCjVK;EDkVL,2BAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,mCAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AANJ;AAOI;EACE,eAAA;EACA,2BAAA;EACA,aAAA;EACA,iBAAA;AALN;AAMM;EACE,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAJR;AAQM;EACE,YAAA;AANR;AAOQ;EACE,cCzTK;ADoTf;AAQM;EACE,uDAAA;AANR;AAOQ;EACE,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AALV;AASI;EACE,sBAAA;EACA,aAAA;EACA,iBAAA;AAPN;AAQM;EACE,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,cC5XO;ED6XP,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AANR;AAOQ;EACE,mBAAA;EACA,cCxYK;ADmYf;AAOQ;EACE,mBC7ZG;ED8ZH,cC1ZS;ADqZnB;AAOQ;EACE,kBAAA;EACA,kBAAA;AALV;AAMU;EACE,kBAAA;EACA,iBAAA;EACA,UAAA;EACA,QAAA;AAJZ;AAKY;EACE,SAAA;AAHd;AAOQ;EACE,UAAA;AALV;AAQM;EACE,uDAAA;AANR;AAOQ;EACE,cChbS;AD2anB;AASI;EACE,aAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;AAPN;AAQM;EACE,YAAA;EACA,WAAA;AANR;AAQM;EACE,cC/bW;EDgcX,gBAAA;EACA,WAAA;AANR;AAOQ;EACE,UAAA;EACA,eAAA;AALV;AAMU;EACE,eAAA;AAJZ;AAOQ;EACE,cC9YK;ADyYf;AAMU;EACE,qBAAA;AAJZ;AAOQ;EACE,iBAAA;AALV;AAOQ;EACE,kBAAA;AALV;AASI;EACE,mBC1dc;ED2dd,YAAA;EACA,aAAA;AAPN;AAUM;EACE,yBAAA;EACA,cCrdC;EDsdD,eAAA;EACA,eAAA;EACA,gBAAA;AARR;AAWM;EACE,iBAAA;EACA,cC7dC;ED8dD,cAAA;EACA,oBAAA;EACA,eAAA;EACA,uBAAA;EACA,qBAAA;EACA,sBAAA;EACA,4BAAA;EACA,qBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;AATR;AAUQ;EACE,qBAAA;AARV;AAaM;EACE,aAAA;AAXR;AASI;EAIE,gBAAA;EACA,iBAAA;EACA,cCrfG;EDsfH,gBAAA;AAVN;AAYQ;EACE,cCngBS;EDogBT,eAAA;EACA,iBAAA;EACA,gBAAA;AAVV;AAYQ;EACE,qBAAA;AAVV;AAYQ;EACE,YAAA;EACA,kBAAA;EACA,iBAAA;AAVV;AAeI;EACE,cC1gBG;ED2gBH,cAAA;EACA,oBAAA;AAbN;AAcM;EACE,eAAA;EACA,YAAA;AAZR;AAcM;EACE,gBAAA;EACA,iBAAA;EACA,cC9hBW;ED+hBX,iBAAA;AAZR;AAaQ;EACE,gBAAA;AAXV;AAaQ;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAXV;AAaQ;EACE,mBAAA;AAXV;AAgBE;EACE,yBCjiBI;ADmhBR;AAeI;EACE,yBCnjBa;EDojBb,qBCpjBa;ADuiBnB;AAcM;EACE,yBCtjBW;EDujBX,qBCvjBW;EDwjBX,mBAAA;AAZR;AAeI;EACE,yBC3iBY;ED4iBZ,qBC5iBY;AD+hBlB;AAeI;EACE,YAAA;EACA,cAAA;EACA,mBAAA;AAbN;;AAkBA;EACE,aAAA;EACA,sBAAA;EACA,iBAAA;AAfF;;AAkBA;EACE,SAAA;AAfF;;AAmBE;EACE,cC7kBS;ED8kBT,eAAA;EACA,0BAAA;AAhBJ;;AAqBA;EACE,cAAA;EACA,mBC9kBa;ED+kBb,cAAA;EACA,eAAA;AAlBF;AAmBE;EACE,gBAAA;AAjBJ;AAkBI;EACE,gBAAA;EACA,eAAA;AAhBN;AAiBM;EACE,gBAAA;AAfR;AAkBI;EACE,eAAA;EACA,0BAAA;EACA,cCrmBO;ADqlBb;AAmBE;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;AAjBJ;AAkBI;EACE,cAAA;AAhBN;;AAqBA;EACE,aAAA;EACA,iBAAA;EACA,yBAAA;AAlBF;AAoBI;EACE,gBAAA;AAlBN;AAqBE;EACE,SAAA;AAnBJ;AAqBE;EACE,cC3nBU;ED4nBV,gBAAA;EACA,eAAA;AAnBJ;AAsBI;EACE,kBAAA;AApBN;AAkBE;EAIE,iBAAA;AAnBJ;AAoBI;EACE,aAAA;AAlBN;AAqBE;EACE,kBAAA;EACA,eAAA;EACA,0BAAA;EACA,cAAA;EACA,eAAA;AAnBJ;;AA0BI;EACE,mBAAA;AAvBN;AAyBI;EACE,kBAAA;EACA,WAAA;EACA,SAAA;AAvBN;AA0BE;EACE,gBAAA;AAxBJ;AAyBI;EACE,kBAAA;EACA,qBAAA;EACA,aAAA;EACA,8BAAA;AAvBN;AAyBQ;EACE,cCtqBI;AD+oBd;AA2BI;EAGE,gBAAA;EACA,YAAA;AA3BN;AA4BM;EACE,YAAA;EACA,aAAA;EACA,gBAAA;AA1BR;AA4BK;EACC,cClsBQ;ADwqBd;AA4BI;EACE,kBAAA;AA1BN;;AA+BA;EACE,iBAAA;EACA,iBAAA;AA5BF;AA6BE;EACE,mBAAA;AA3BJ;AA6BE;EACE,iBAAA;AA3BJ;;AAkCI;EACE,kBAAA;EACA,WAAA;EACA,SAAA;AA/BN;AAkCE;EACE,gBAAA;EACA,gBAAA;EACA,cCnqBO;ADmoBX;AAkCE;EACE,kBAAA;AAhCJ;AAkCE;EACE,cChuBS;EDiuBT,gBAAA;EACA,eAAA;AAhCJ;AAkCE;EACE,cAAA;EACA,gBAAA;AAhCJ;AAmCI;EACE,gBAAA;AAjCN;AAoCE;EACE,gBAAA;AAlCJ;;AAsCA;EACE,WAAA;AAnCF;;AAqCA;EACE,WAAA;AAlCF;;AAsCI;EACE,cCvvBG;EDwvBH,cAAA;EACA,oBAAA;AAnCN;AAoCM;EACE,YAAA;EACA,YAAA;AAlCR;AAoCM;EACE,gBAAA;EACA,iBAAA;EACA,cC3wBW;ED4wBX,iBAAA;EACA,sBAAA;AAlCR;AAmCQ;EACE,cCrwBD;EDswBC,gBAAA;AAjCV;AAmCQ;EACE,mBAAA;AAjCV;AAqCI;EACE,iBAAA;EACA,cCzxBa;ADsvBnB;AAoCM;EACE,SAAA;AAlCR;;AA0CI;EACE,kBAAA;EACA,WAAA;EACA,SAAA;AAvCN;;AA8CE;EACE,cClvBW;EDmvBX,gBAAA;AA3CJ;AA6CE;EACE,cClzBe;ADuwBnB;AA4CI;EACE,gBAAA;AA1CN;AA4CI;EACE,gBAAA;AA1CN;AA6CE;EACE,cAAA;EACA,cAAA;AA3CJ;AA4CI;EACE,gBAAA;EACA,eAAA;AA1CN;AA8CI;EACE,qBAAA;AA5CN;AA+CE;EACE,mCAAA;EACA,cAAA;EACA,kBAAA;AA7CJ;AA8CI;EACE,UAAA;EACA,aAAA;EACA,kCAAA;AA5CN;AA6CM;EACE,2BAAA;EACA,sBAAA;AA3CR;AA6CM;EACE,aAAA;AA3CR;AA4CQ;EACE,yBAAA;AA1CV;AA4CQ;EACE,eAAA;EACA,gBAAA;AA1CV;AA4CQ;EACE,eAAA;AA1CV;AA4CQ;EACE,eAAA;EACA,gBAAA;AA1CV;AA2CU;EACE,qBAAA;AAzCZ;AA6CM;EACE,aAAA;AA3CR;AA4CQ;EACE,yBC11BF;ED21BE,qBC31BF;ED41BE,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;AA1CV;AA2CU;EACE,qBCj3BO;EDk3BP,yBCl3BO;ADy0BnB;AA0CY;EACE,mBAAA;AAxCd;AAyCc;EACE,WAAA;AAvChB;AA0CY;EACE,qBC13BK;ED23BL,yBC33BK;ADm1BnB;AA2CU;EACE,eAAA;EACA,cAAA;EACA,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,qBAAA;AAzCZ;AA0CY;EACE,qBAAA;AAxCd;AA2CU;EACE,qBCz3BM;ED03BN,yBC13BM;ADi1BlB;;AAmDE;EACE,yBCr4Bc;EDs4Bd,qBCt4Bc;ADs1BlB;AAkDE;EACE,wBAAA;EACA,2BAAA;AAhDJ;;AAmDA;EACE,oCAAA;EACA,gCAAA;EACA,yBAAA;AAhDF;AAkDE;EACE,4EAAA;EACA,wEAAA;AAhDJ;AAkDE;EACE,wBAAA;EACA,2BAAA;AAhDJ;;AAmDA;EACE,oCAAA;EACA,gCAAA;EACA,oCAAA;EACA,yBAAA;AAhDF;AAiDE;EACE,oCAAA;EACA,yBAAA;AA/CJ;AAgDI;EACE,oCAAA;EACA,yBAAA;EACA,gCAAA;AA9CN;AAiDE;EACE,qBAAA;EACA,oCAAA;EACA,gCAAA;EACA,yBAAA;AA/CJ;AAgDI;EACE,qBAAA;EACA,oCAAA;EACA,gCAAA;EACA,mBAAA;AA9CN;AAiDE;EACE,oCAAA;EACA,gCAAA;EACA,yBAAA;AA/CJ;AAiDE;EACE,wBAAA;EACA,2BAAA;AA/CJ;AAiDE;EACE,oCAAA;EACA,gCAAA;AA/CJ;;AAkDA;EACE,yBC/8BW;EDg9BX,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,eC/7BO;EDg8BP,kBAAA;EACA,qBAAA;EACA,mBAAA;AA/CF;AAgDE;EACE,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,cC19BW;ED29BX,gBAAA;AA9CJ;AA+CI;EACE,yBAAA;EACA,yBAAA;EACA,mBAAA;AA7CN;AAgDE;EACE,yBAAA;EACA,cCr+BS;ADu7Bb;AAgDE;EACE,yBCv+BW;EDw+BX,qBCx+BW;EDy+BX,eAAA;AA9CJ;AAgDE;EACE,aAAA;AA9CJ;AAgDE;EACE,YAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;AA9CJ;AAgDE;EACE,yBCv/BS;EDw/BT,qBCx/BS;AD08Bb;AAgDI;EACE,yBC1/BS;ED2/BT,qBC3/BS;AD68Bf;AAiDE;EACE,yBC//BW;EDggCX,qBChgCW;EDigCX,cAAA;AA/CJ;AAiDI;EACE,yBCpgCS;EDqgCT,qBCrgCS;EDsgCT,cAAA;EACA,UAAA;AA/CN;;AAoDA;EACE,cCx9Ba;ADu6Bf;;AAoDA;EACE,YAAA;EACA,cC79Ba;AD46Bf;;AAoDA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cCr+Ba;ADo7Bf;;AAqDA;EACE;IACE,kCAAA;EAlDF;EAoDA;IACE,kCAAA;EAlDF;AACF;AAqDA;EAEI;IACE,eAAA;EApDJ;EAsDE;IACE,eAAA;EApDJ;EAuDA;IACE,kCAAA;EArDF;EAuDI;IACE,eAAA;EArDN;EAuDI;IACE,eAAA;EArDN;EAwDE;IACE,QAAA;EAtDJ;EAyDA;IACE,kCAAA;EAvDF;AACF;AA2DA;EAEE;IACE,qBAAA;EA1DF;EA2DE;IACE,cAAA;IACA,kBAAA;IACA,gBAAA;EAzDJ;EA0DI;IACE,UAAA;IACA,WAAA;IACA,mBAAA;EAxDN;EAyDM;IACE,gBAAA;EAvDR;EA0DI;IACE,WAAA;IACA,WAAA;IACA,gBAAA;EAxDN;EA0DQ;IACE,eAAA;EAxDV;EA0DQ;IACE,eAAA;EAxDV;EA4DI;IACE,kBAAA;IACA,WAAA;IACA,SAAA;IACA,aAAA;IACA,2BAAA;EA1DN;EA2DM;IACE,SAAA;EAzDR;EA8DA;IACE,iBAAA;EA5DF;EA6DE;IACE,iBAAA;IACA,wBAAA;IACA,gBAAA;EA3DJ;EA+DA;IACE,UAAA;IACA,YAAA;IACA,cAAA;EA7DF;EA+DA;IACE,iBAAA;IACA,UAAA;IACA,cAAA;EA7DF;EA8DE;IACE,eAAA;EA5DJ;EAkEI;IACE,gBAAA;EAhEN;EAmEE;IACE,gBAAA;EAjEJ;EAkEI;IACE,iBAAA;EAhEN;EAiEM;IACE,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,cAAA;IACA,gBAAA;EA/DR;EAkEI;IACE,kBAAA;EAhEN;EAkEQ;IACE,iBAAA;EAhEV;EAkEQ;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAhEV;EAoEQ;IACE,eAAA;EAlEV;EAoEQ;IACE,eAAA;EAlEV;EAsEI;IACE,cAAA;EApEN;EAqEM;IACE,kBAAA;EAnER;EAqEM;IACE,iBAAA;EAnER;EAsEI;IACE,gBAAA;IACA,iBAAA;EApEN;EAsEI;IACE,mBAAA;EApEN;EAsEQ;IACE,eAAA;IACA,iBAAA;IACA,gBAAA;EApEV;EAsEQ;IACE,oBAAA;EApEV;EAyEE;IACE,4BAAA;IACA,YAAA;IACA,kBAAA;EAvEJ;EAwEI;IACE,YAAA;EAtEN;EAwEI;IACE,cAAA;IACA,WAAA;IACA,kBAAA;IACA,cAAA;EAtEN;EA6EA;IACE,eAAA;EA3EF;EA6EA;IACE,eAAA;IACA,0BAAA;EA3EF;EA6EA;IACE,eAAA;EA3EF;EAiFE;IACE,gBAAA;EA/EJ;EAmFM;IACE,aAAA;EAjFR;EA+EI;IAIE,8BAAA;EAhFN;EAkFQ;IACE,YAAA;IACA,mBAAA;EAhFV;AACF;AAwFE;EACE,UAAA;EACA,mBAAA;AAtFJ;;AA0FA,aAAA;AACA;EACE,aAAA;AAvFF;;AAyFA;EACE,qCAAA;EACA,cAAA;AAtFF;;AAwFA;EACE,sCAAA;AArFF;;AAwFA;EACE,0CAAA;AArFF;;AAuFA;EACE,0CAAA;EACA,6BAAA;AApFF;;AAsFA;EACE,2BAAA;AAnFF;;AAuFA;;EAEE,wBAAA;AApFF;;AAsFA;EACE,YAAA;AAnFF;;AAqFA;EACE,aAAA;AAlFF;;AAoFA;;EAEE,cAAA;AAjFF;;AAoFA;EACE,cClzCkB;EDmzClB,eCrxCQ;EDsxCR,8BAAA;EACA,aAAA;EACA,WAAA;EACA,aAAA;EACA,kCAAA;EACA,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,mCAAA;EACA,YAAA;AAjFF;AAkFE;EACE,gBAAA;EACA,eCnyCI;ADmtCR;AAkFE;EACE,yBAAA;AAhFJ;AAkFE;EACE,aAAA;AAhFJ;AAkFE;EACE,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AAhFJ;AAiFI;EACE,yBAAA;EACA,iBAAA;EACA,cC9zCE;AD+uCR;AAgFM;EACE,qBC/zCU;EDg0CV,yBCh0CU;EDi0CV,cAAA;AA9ER;AAiFI;EACE,cAAA;AA/EN;AAkFE;EACE,UAAA;EACA,eAAA;EACA,cChyCW;ADgtCf;AAiFI;EACE,eAAA;EACA,qBAAA;AA/EN;AAiFI;EACE,kBAAA;AA/EN;;AAmFA;EACE,mBAAA;EACA,WAAA;EACA,WAAA;AAhFF;AAiFE;EACE,cCr2CS;EDs2CT,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,8BAAA;EACA,UAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;AA/EJ;AAiFE;EACE,WAAA;AA/EJ;AAgFI;EACE,kBAAA;AA9EN;AAgFI;EACE,qBAAA;AA9EN;AAiFE;EACE,aAAA;EACA,kCAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,cCh4CS;ADizCb;AAgFI;EACE,kBAAA;EACA,gBAAA;EACA,iBAAA;AA9EN;AAiFE;EACE,cCh5CgB;ADi0CpB;AAgFI;EACE,yBAAA;EACA,cC34CO;ED44CP,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;AA9EN;AA+EM;EACE,yBCj5CK;EDk5CL,cAAA;AA7ER;AAiFE;EACE,yBCv5CS;EDw5CT,cAAA;AA/EJ;;AAmFA;EACE,gBAAA;AAhFF;AAiFE;EACE,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,cCx6Ce;ADy1CnB;AAiFE;EACE,cC92CO;AD+xCX;AAiFE;EACE,cCl3CW;ADmyCf;AAiFE;EACE,kBAAA;AA/EJ;AAiFE;EACE,iBAAA;AA/EJ;AAiFE;EACE,cAAA;EACA,yBCl7CS;EDm7CT,YAAA;EACA,yBAAA;AA/EJ;AAgFI;EACE,oCAAA;EACA,gCAAA;AA9EN;AAgFI;EACE,yBCp8CO;EDq8CP,yBCr8CO;ADu3Cb;AA+EM;EACE,kBAAA;AA7ER;AAgFI;EACE,aAAA;AA9EN;AAgFI;EACE,cCp8CO;EDq8CP,mBAAA;EACA,yBAAA;AA9EN;AA+EM;EACE,cAAA;EACA,8BAAA;EACA,qBAAA;AA7ER;AAiFE;EACE,YAAA;AA/EJ;AAiFE;EACE,cC19CgB;ED29ChB,mBAAA;EACA,cAAA;EACA,gBAAA;AA/EJ;;AAmFA;EACE;IACE,aAAA;EAhFF;EAkFA;IACE,cAAA;IACA,gBAAA;EAhFF;EAkFA;IACE,WAAA;EAhFF;EAkFA;IACE,kBAAA;IACA,cAAA;EAhFF;EAiFE;IACE,eAAA;EA/EJ;EAkFA;IACE,iBAAA;EAhFF;EAiFE;IACE,eAAA;EA/EJ;AACF;AAmFA;EACE;IACE,YAAA;IACA,eAAA;EAjFF;EAmFA;IACE,YAAA;EAjFF;AACF","sourcesContent":["@import '../../../app/variables.scss';\nbody {\n  overflow-y: scroll !important;\n}\n.psuedo-link {\n  cursor: pointer;\n}\n\n.helper-text-wrapper {\n  display: grid;\n}\n\n.helper-text-mobile {\n  position: relative;\n  top: 16%;\n  left: 8%;\n  pointer-events: none;\n}\n\n.helper-text-button, .helper-text-mobile {\n  grid-area: 1/1;\n}\n\ni.fa.fa-question {\n  color: $evanta-blue;\n  font-size: 13px;\n  position: absolute;\n  pointer-events: fill;\n  &.question-larger {\n    font-size: 20px;\n  }\n}\n\n@media screen and (min-device-width: 992px) {\n  .logoImageWide {\n    display: block;\n  }\n  .logoImageStacked {\n    display: none;\n  }\n}\n\n@media screen and (max-device-width: 991px) and (min-device-width: 768px) {\n  .logoImageWide {\n    display: none;\n  }\n  .logoImageStacked {\n    display: block;\n  }\n}\n\n@media screen and (max-device-width: 767px) {\n  .logoImageWide {\n    display: block;\n  }\n  .logoImageStacked {\n    display: none;\n  }\n}\n\n// header\n.virtual-portal-header {\n  display: flex;\n  flex: 1;\n  width: 100%;\n  background-color: $gartner-blue;\n  min-height: 100px;\n  align-items: start;\n  box-shadow: 1px 5px 8px 0px #9c9898;\n  .container {\n    white-space: pre-wrap;\n    grid-template-columns: 30% 50% 20%;\n    grid-gap: 7px;\n    display: grid;\n    cursor: default;\n    color: #ffffff;\n    padding-top: 25px;\n    position: relative;\n    .logo img {\n      margin: 10px 0 0;\n      width: 179px;\n      max-width: 179px;\n      height: auto;\n    }\n    .logo .logoImageStacked {\n      height: 58px;\n    }\n    .title {\n      .centered {\n        margin: 0 0 0 0;\n        h4 {\n          font-size: 24px;\n        }\n        h5 {\n          font-weight: 100;\n          font-size: 18px;\n          margin-top: -5px;\n        }\n      }\n    }\n    .info {\n      display: inline-block;\n      position: relative;\n      a {\n        float: right;\n        background-color: #ffffff;\n        padding: 1px 10px;\n        border-radius: 50%;\n        color: $gartner-blue;\n        font-weight: 900;\n        margin-right: 15px;\n        &:hover {\n          text-decoration: none;\n          color: $gartner-blue;\n          opacity: 0.8;\n        }\n      }\n      .user-profile-image{\n        max-height: 27px;\n        max-width: 27px;\n        &:hover {\n          cursor: pointer;\n        }\n      }\n      .menu {\n        width: 236px;\n        position: absolute;\n        top: 75px;\n        right: 0;\n        background: #ffffff;\n        color: $eblack;\n        z-index: 999;\n        padding: 26px;\n        box-shadow: 2px 5px 7px 0px #bfbdbd;\n        .menu-subheader {\n          color: $medium-gray;\n          font-size: 14px;\n          line-height: 22px;\n          letter-spacing: .88px;\n          font-weight: 400;\n        }\n        .menu-name {\n          white-space: pre-wrap;\n          overflow-wrap: break-word;\n        }\n        .menu-title {\n          white-space: pre;\n          margin-bottom: 0;\n        }\n        .menu-title {\n          color: $medium-light-gray;\n          font-size: 12px;\n          line-height: 22px;\n          letter-spacing: .88px;\n          text-transform: uppercase;\n        }\n        hr {\n          margin: 2rem 0;\n        }\n        ul, .menu-item {\n          list-style-type: none;\n          list-style-position:inside;\n          margin:0.5rem 0;\n          letter-spacing: .88px;\n          padding:0;\n          font-size: 14px;\n          a {\n            font-weight: 400;\n            margin:0;\n            float: none;\n            padding:0;\n            color: $medium-dark-gray;\n          }\n        }\n        .menu-item, a:hover{\n          font-weight: 600;\n          cursor: pointer;\n          color: $gartner-blue;\n        }\n      }\n    }\n  }\n}\n\n// welcome section\n.welcome {\n  margin: 5px 0 30px;\n  h2 {\n    color: $eblack;\n    font-size: 40px;\n  }\n  h5 {\n    color: $medium-dark-gray;\n    text-transform: none;\n    letter-spacing: .88px;\n    font-size: 14px;\n  }\n}\n// alert section\n.alert-section {\n  height: auto;\n  .header-alert {\n    background: $solar-tertiary;\n    color: #ffffff;\n    width: auto;\n    display: inline-block;\n    padding: 10px 15px;\n    margin-right: 10px;\n    font-size: 1rem;\n    border-radius: 0px 0px 3px 3px;\n    &.gray {\n      background: $medium-dark-gray;\n    }\n    &:hover {\n      text-decoration: none;\n      cursor: pointer;\n    }\n    .fa {\n      font-size: 36px;\n      vertical-align: middle;\n      padding: 0 0 1px 10px;\n    }\n  }\n}\n// emergency broadcast message section\n.emergency-broadcast-section {\n  height: auto;\n  width: 100%;\n  max-width: none !important;\n  box-shadow: 1px 5px 8px 0px #9c9898;\n  margin-bottom: 5px;\n  .header-emergency-broadcast {\n    background: $solar;\n    color: #ffffff;\n    width: 100%;\n    padding: 10px 15px;\n    font-size: 1.2rem;\n  }\n  .body-emergency-broadcast {\n    font-size: 1rem;\n  }\n}\n\n.no-agenda {\n  min-height: calc(100vh - 225px);\n  padding-top: 50px;\n  h1, h4 {\n    color: $vp-black;\n  }\n  h4 {\n    font-weight: 600;\n  }\n  h5 {\n    text-transform: uppercase;\n    color: $medium-dark-gray;\n    font-size: 14px;\n    letter-spacing: .8px;\n  }\n  p {\n    color: $medium-dark-gray;\n    font-size: 18px;\n    margin-top: 20px;\n    font-weight: 100;\n    a {\n      text-decoration: underline;\n    }\n  }\n}\n// session index\n.virtual-sessions-page {\n  .session-advisory {\n    color: $medium-dark-gray;\n  }\n  button.filter-tabs {\n    border: 2px solid $evanta-blue;\n    min-width: 250px;\n    cursor: pointer;\n    border-radius: 3px;\n    padding: 0;\n    .my-schedule, .agenda {\n      font-size: 1rem;\n      width: 50%;\n      background: #ffffff;\n      color: $evanta-blue;\n      width: 50%;\n      float: left;\n      padding: 4px;\n      &.active {\n        background: $evanta-blue;\n        color: #ffffff;\n      }\n    }\n    &:focus {\n      outline-color: $evanta-blue;\n    }\n  }\n  .session-link {\n    width: calc(100% - 100px);\n    &:hover{\n      text-decoration: none;\n    }\n  }\n  .session-icons {\n    position: inherit;\n    display: grid;\n    max-height: 184px;\n    right: 10px;\n    button {\n      vertical-align: middle;\n      margin: auto;\n      margin-right: 0px;\n    }\n    .editp2plink{\n      display: grid;\n      text-decoration: none;\n    }\n    .editp2p{\n      border-radius: 5px;\n      font-size: 14px;\n      line-height: 1rem;\n      padding: 10px 3px;\n      border: 2px solid $solar;\n      color: $solar;\n      vertical-align: middle;\n      background-color: transparent;\n      &.btn-danger {\n        color: #ffffff;\n      }\n      &:hover{\n        border-color: $solar-secondary;\n        background-color: $solar-secondary;\n        color: #ffffff;\n      }\n      &:focus {\n        outline: none;\n        box-shadow: none;\n      }\n    }\n  }\n  .time-block-section {\n    background: $light-gray;\n    margin: 30px 0;\n    padding: 10px;\n    font-size: .8rem;\n    color: $gartner-blue;\n    font-weight: 600;\n    border-radius: 3px;\n    p.formatted-time {\n      margin: 20px 0;\n      font-weight: 700;\n      font-size: 14px;\n      text-transform: uppercase;\n    }\n  }\n  .day-break {\n    border-top: 2px dashed $medium-light-gray;\n  }\n  .session {\n    grid-template-columns: 17% 68% 15%;\n    display: grid;\n    background: #ffffff;\n    color: $eblack;\n    border: 0.5px solid $light-gray;\n    line-height: 10px;\n    text-decoration: none;\n    position: relative;\n    box-shadow: 2px 2px 7px 0px #bfbdbd;\n    margin: 20px 0;\n    min-height: 200px;\n    border-radius: 3px;\n    &.itinerary {\n      padding: 0 15px;\n      grid-template-columns: 100%;\n      min-height: 0;\n      text-indent: 20px;\n      p {\n        margin: 10px;\n        text-transform: uppercase;\n        font-style: italic;\n        font-weight: 400;\n        font-size: 14px;\n      }\n    }\n    &.session-over {\n      .container {\n        opacity: 0.6;\n        p, h3 {\n          color: $vp-dark-gray;\n        }\n      }\n      .session-cta-wrapper {\n        box-shadow: inset 0 0 0 100vw rgba(239,239,240,0.78);\n        .registration-button {\n          font-size: 1.25rem;\n          border-radius: 50%;\n          width: 55px;\n          height: 55px;\n        }\n      }\n    }\n    .session-cta-wrapper {\n      background-size: cover;\n      display: flex;\n      max-height: 198px;\n      .registration-button {\n        margin: auto;\n        background: #1f96ff;\n        border-radius: 35px;\n        color: $gartner-blue;\n        border: none;\n        font-weight: 600;\n        text-align: left;\n        font-size: .88rem;\n        padding: 10px;\n        width: 75%;\n        height: 60px;\n        text-align: center;\n        line-height: 15px;\n        &.registered {\n          background: #B8DEFF;\n          color: $gartner-blue;\n        }\n        &.p2pSession {\n          background: $light-gray;\n          color: $medium-dark-gray;\n        }\n        .icon-and-text {\n          position: relative;\n          padding-left: 30px;\n          i {\n            position: absolute;\n            font-size: 1.5rem;\n            left: 10px;\n            top: 3px;\n            &.fa-minus {\n              top: -4px;\n            }\n          }\n        }\n        &:focus{\n          outline: 0;\n        }\n      }\n      &.not-authorized {\n        box-shadow: inset 0 0 0 100vw rgba(239,239,240,0.75);\n        .registration-button {\n          color: $medium-dark-gray;\n        }\n      }\n    }\n    .container {\n      display: flex;\n      flex-wrap: wrap;\n      flex-direction: column;\n      padding: 15px 35px;\n      margin-top: -10px;\n      .inner-wrapper {\n        margin: auto;\n        width: 100%;\n      }\n      .action-links {\n        color: $medium-dark-gray;\n        margin-top: 10px;\n        width: 100%;\n        .more, .add-to-calendar {\n          width: 50%;\n          font-size: 14px;\n          &:hover {\n            cursor: pointer;\n          }\n        }\n        .add-to-calendar, .more {\n          color: $vp-dark-gray;\n          &:hover {\n            text-decoration: none;\n          }\n        }\n        .add-to-calendar {\n          margin-left: 45px;\n        }\n        .fa {\n          margin-right: 10px;\n        }\n      }\n    }\n    .session-time {\n      background: $medium-light-gray;\n      color: white;\n      padding: 10px;\n    }\n    .session-header {\n      .session-type {\n        text-transform: uppercase;\n        color: $eblack;\n        margin: 8px 0px;\n        font-size: 14px;\n        font-weight: 600;\n      }\n       // MK ~ please don't remove commented out autoprefixers below 08/18/2020\n      .session-name {\n        padding-top: 10px;\n        color: $eblack;\n        display: block;\n        display: -webkit-box;\n        max-width: 100%;\n        margin: -15px auto 10px;\n        -webkit-line-clamp: 2;\n        /* autoprefixer: off */\n        -webkit-box-orient: vertical;\n        /* autoprefixer: on */\n        overflow: hidden;\n        text-overflow: ellipsis;\n        font-size: 26px;\n        font-weight: 600;\n        &.open-true {\n          -webkit-line-clamp: 3;\n        }\n      }\n    }\n    .session-information {\n      &.hidden{\n        display: none;\n      }\n      max-width: 900px;\n      padding-top: 10px;\n      color: $eblack;\n      line-height: 1em;\n      .session-body {\n        p, li {\n          color: $medium-dark-gray;\n          font-size: 17px;\n          line-height: 20px;\n          font-weight: 400;\n        }\n        ul {\n          list-style-type: none;\n        }\n        ul > li:before {\n          content: '–';\n          position: absolute;\n          margin-left: -1em;\n        }\n      }\n    }\n\n    .user-list.speaker {\n      color: $eblack;\n      margin: 10px 0;\n      text-transform: none;\n      img {\n        max-width: 65px;\n        height: auto;\n      }\n      .user-info {\n        font-weight: 100;\n        font-size: 1.2rem;\n        color: $medium-dark-gray;\n        line-height: 15px;\n        .full-name {\n          font-weight: 600;\n        }\n        .speaker-type {\n          text-transform: uppercase;\n          font-size: .75rem;\n          font-weight: 400;\n          color: #000000;\n          margin-top: 9px;\n        }\n        div {\n          margin: 0px 0px 5px;\n        }\n      }\n    }\n  }\n  .btn.btn-danger {\n    background-color: $solar;\n    &:disabled, &.disabled {\n      background-color: $medium-dark-gray;\n      border-color: $medium-dark-gray;\n      &:hover {\n        background-color: $medium-dark-gray;\n        border-color: $medium-dark-gray;\n        cursor: not-allowed;\n      }\n    }\n    &:hover{\n      background-color: $solar-secondary;\n      border-color: $solar-secondary;\n    }\n    &.closing-details {\n      margin: auto;\n      display: block;\n      margin-bottom: 50px;\n    }\n  }\n}\n\n.header-router-footer {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n}\n\n.header-router {\n  flex: 1;\n}\n\n.session-closing-details {\n  .pseudo-link {\n    color: $light-base;\n    cursor: pointer;\n    text-decoration: underline;\n  }\n}\n\n// footer\nfooter.virtual-footer {\n  flex-shrink: 0;\n  background: $gartner-blue;\n  color: #ffffff;\n  padding: 15px 0;\n  .session-closing-details {\n    margin-top: 25px;\n    p {\n      font-weight: 100;\n      font-size: 26px;\n      strong {\n        font-weight: 600;\n      }\n    }\n    .pseudo-link {\n      cursor: pointer;\n      text-decoration: underline;\n      color: $light-base;\n    }\n  }\n  .copyright {\n    display: block;\n    text-align: center;\n    font-size: 14px;\n    font-style: italic;\n    margin: 25px auto;\n    a {\n      color: #ffffff;\n    }\n  }\n}\n\n.react-modal.error-modal, .react-modal.info-modal, .react-modal.evaluation-modal {\n  padding: 45px;\n  min-height: 500px;\n  background-color: #ffffff;\n  .button-container {\n    button {\n      margin-top: 40px;\n    }\n  }\n  .pm-info > p {\n    margin: 0;\n  }\n  .live-chat-link{\n    color: $evanta-blue;\n    font-weight: 600;\n    cursor: pointer;\n  }\n  &.confirm{\n    .generic-info-modal-content p {\n      text-align: center;\n    }\n    min-height: 275px;\n    .button-container{\n      display: flex;\n    }\n  }\n  .modalCancelText {\n    text-align: center;\n    cursor: pointer;\n    text-decoration: underline;\n    color: #4330ff;\n    font-size: 24px;\n  }\n}\n\n// evaluation modal\n.react-modal.evaluation-modal {\n  .header {\n    h3 {\n      margin-bottom: 20px;\n    }\n    .fa-times-thin {\n      position: absolute;\n      right: 15px;\n      top: 10px;\n    }\n  }\n  .evaluation-modal-content {\n    margin-top: 2rem;\n    .evaluation-modal-stars {\n      text-align: center;\n      margin: 0 3.5rem 1rem;\n      display: flex;\n      justify-content: space-between;\n      .fa.fa-star-o {\n        &.unchecked {\n          color: $evanta-blue;\n        }\n      }\n    }\n    textarea.form-control {\n      // border: none;\n      // padding: 0;\n      min-height: 90px;\n      resize: none;\n      &:focus {\n        border: none;\n        outline: none;\n        box-shadow: none;\n      }\n    }::placeholder {\n      color: $medium-gray;\n    }\n    .button-container {\n      text-align: center;\n    }\n  }\n}\n\n.follow-up {\n  padding-top: 10px;\n  margin-right: 5px;\n  .follow-up-label {\n    padding-right: 20px;\n  }\n  input {\n    margin-right: 5px;\n  }\n}\n\n// generic modal\n.react-modal.generic.info-modal {\n  .generic-info-modal-header {\n    .fa-times-thin {\n      position: absolute;\n      right: 15px;\n      top: 10px;\n    }\n  }\n  h4 {\n    font-weight: 600;\n    margin:\t0 0 22px;\n    color: $vp-black;\n  }\n  .fa {\n    margin-right: 10px;\n  }\n  a {\n    color: $light-base;\n    font-weight: 600;\n    cursor: pointer;\n  }\n  .eblue-button a {\n    color: #ffffff;\n    font-weight: 400;\n  }\n  .button-container {\n    hr {\n      margin-top: 45px;\n    }\n  }\n  .take-event-eval {\n    font-weight: 400;\n  }\n}\n\n.react-modal.info-pop-up {\n  height: 90%;\n}\n.react-modal.double-booking, .react-modal.troubleshooting {\n  height: 70%;\n}\n.react-modal.wishlist-user-info {\n  .generic-info-modal-content {\n    .user-list {\n      color: $eblack;\n      margin: 10px 0;\n      text-transform: none;\n      img {\n        width: 110px;\n        height: auto;\n      }\n      .user-info {\n        font-weight: 400;\n        font-size: 1.2rem;\n        color: $medium-dark-gray;\n        line-height: 20px;\n        padding: 20px 0 0 10px;\n        .full-name {\n          color: $eblack;\n          font-weight: 800;\n        }\n        div {\n          margin: 0px 0px 5px;\n        }\n      }\n    }\n    .bio {\n      padding-top: 20px;\n      color: $medium-dark-gray;\n      p {\n        margin: 0;\n      }\n    }\n  }\n}\n// generic error\n.react-modal.error-modal {\n  .generic-error-modal-header {\n    .fa-times-thin {\n      position: absolute;\n      right: 15px;\n      top: 10px;\n    }\n  }\n}\n\n// closing details modal\n.closing-details {\n  .see-you-soon {\n    color: $vp-dark-gray;\n    margin: 30px 0 0;\n  }\n  .thank-you-body-content {\n    color: $medium-dark-gray;\n    h6 {\n      font-weight: 600;\n    }\n    p {\n      font-weight: 300;\n    }\n  }\n  .take-event-eval {\n    display: block;\n    margin: 25px 0;\n    .fa {\n      font-weight: 600;\n      font-size: 18px;\n    }\n  }\n  button, a {\n    &:hover {\n      text-decoration: none;\n    }\n  }\n  .upcoming-event-row {\n    box-shadow: 2px 2px 7px 0px #bfbdbd;\n    margin: 15px 0;\n    border-radius: 3px;\n    .container {\n      padding: 0;\n      display: grid;\n      grid-template-columns: 20% 55% 25%;\n      .event-image {\n        background-position: center;\n        background-size: cover;\n      }\n      .main-content {\n        padding: 10px;\n        .event-date {\n          text-transform: uppercase;\n        }\n        h5 {\n          font-size: 14px;\n          font-weight: 600;\n        }\n        h6 {\n          font-size: 12px;\n        }\n        .learn-more {\n          font-size: 12px;\n          font-weight: 500;\n          &:hover{\n            text-decoration: none;\n          }\n        }\n      }\n      .register-button-container {\n        display: grid;\n        button.btn.btn-danger {\n          background-color: $solar;\n          border-color: $solar;\n          vertical-align: middle;\n          margin: auto;\n          margin-right: 10px;\n          padding: 0;\n          &.registered {\n            border-color: $medium-dark-gray;\n            background-color: $medium-dark-gray;\n            a {\n              cursor: not-allowed;\n              .fa {\n                margin: 1px;\n              }\n            }\n            &:hover {\n              border-color: $medium-dark-gray;\n              background-color: $medium-dark-gray;\n            }\n          }\n          a {\n            font-size: 11px;\n            color: #ffffff;\n            display: block;\n            padding: 6px 12px 6px;\n            font-weight: 400;\n            letter-spacing: .5px;\n            &:hover{\n              text-decoration: none;\n            }\n          }\n          &:hover {\n            border-color: $solar-secondary;\n            background-color: $solar-secondary;\n          }\n        }\n      }\n    }\n  }\n}\n\n// general css\n.btn-danger {\n  &:hover{\n    background-color: $solar-secondary;\n    border-color: $solar-secondary;\n  }\n  &:focus {\n    outline: none !important;\n    box-shadow: none !important;\n  }\n}\n.btn-danger-tertiary {\n  background-color: $solar-tertiary !important;\n  border-color: $solar-tertiary !important;\n  color: #ffffff !important;\n\n  &:hover {\n    background-color: darken($solar-tertiary, 8%) !important;\n    border-color: darken($solar-tertiary, 8%) !important;\n  }\n  &:focus {\n    outline: none !important;\n    box-shadow: none !important;\n  }\n}\n.btn-primary {\n  background-color: $light-base !important;\n  border-color: $light-base !important;\n  border: 2px solid $light-base !important;\n  color: #ffffff !important;\n  &.cancel {\n    background-color: #ffffff !important;\n    color: $light-base !important;\n    &:hover {\n      background-color: #ffffff !important;\n      color: $light-active !important;\n      border-color: $light-active !important;\n    }\n  }\n  &:disabled {\n    opacity: 1 !important;\n    background-color: #E1E8F4 !important;\n    border-color: #E1E8F4 !important;\n    color: $gartner-blue !important;\n    &:hover {\n      opacity: 1 !important;\n      background-color: #E1E8F4 !important;\n      border-color: #E1E8F4 !important;\n      cursor: not-allowed;\n    }\n  }\n  &:hover {\n    background-color: #011D4B !important;\n    border-color: #011D4B !important;\n    color: #ffffff !important;\n  }\n  &:focus {\n    outline: none !important;\n    box-shadow: none !important;\n  }\n  &:active {\n    background-color: #011D4B !important;\n    border-color: #011D4B !important;\n  }\n}\n.eblue-button {\n  background-color: $light-base;\n  color: #ffffff;\n  border: 2px solid $light-base;\n  border-radius: 5px;\n  font-size: $medium;\n  padding: 10px 15px;\n  letter-spacing: 1.5px;\n  white-space: nowrap;\n  &:disabled {\n    opacity: 0.6;\n    background-color: #ffffff;\n    border: 2px solid $light-active;\n    color: $light-active;\n    font-weight: 400;\n    &:hover {\n      border: 2px solid $light-active;\n      background-color: inherit;\n      cursor: not-allowed;\n    }\n  }\n  &:active {\n    background-color: #ffffff;\n    color: $light-base;\n  }\n  &:hover {\n    background-color: $light-active;\n    border-color: $light-active;\n    cursor: pointer;\n  }\n  &:focus {\n    outline: none;\n  }\n  &.open-chat-window {\n    margin: auto;\n    display: block;\n    padding: 4px 6px;\n    font-size: 1rem;\n    letter-spacing: inherit;\n  }\n  &.give-feedback {\n    background-color: $light-base;\n    border-color: $light-base;\n\n    &:hover {\n      background-color: $light-active;\n      border-color: $light-active;\n    }\n  }\n  &.feedback-given {\n    background-color: $light-active;\n    border-color: $light-active;\n    color: #ffffff;\n\n    &:disabled {\n      background-color: $light-active;\n      border-color: $light-active;\n      color: #ffffff;\n      opacity: 1;\n    }\n  }\n}\n\n.center-progress-display i.fa-spinner {\n  color: $vp-dark-gray;\n}\n\n.fa-times-thin:before {\n  content: '\\00d7';\n  color: $vp-dark-gray;\n}\n\nhr {\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: 400;\n  margin: 0 0 22px;\n  color: $vp-dark-gray;\n}\n\n\n@media only screen and (max-width : 1200px) {\n  .virtual-sessions-page .session {\n    grid-template-columns: 20% 60% 20%;\n  }\n  .virtual-sessions-page .session-timeslots {\n    grid-template-columns: 20% 60% 20%;\n  }\n}\n\n@media only screen and (max-width : 992px) {\n  .welcome {\n    h2 {\n      font-size: 42px;\n    }\n    h5 {\n      font-size: 12px;\n    }\n  }\n  .virtual-sessions-page .session {\n    grid-template-columns: 25% 50% 25%;\n    .session-header {\n      .session-name {\n        font-size: 24px;\n      }\n      .session-type {\n        font-size: 12px;\n      }\n    }\n    .session-icons {\n      right: 0;\n    }\n  }\n  .virtual-sessions-page .session-timeslots {\n    grid-template-columns: 25% 50% 25%;\n  }\n\n}\n\n@media only screen and (max-width : 767px) {\n  // header\n  .virtual-portal-header {\n    display: inline-block;\n    .container {\n      display: block;\n      position: relative;\n      padding-top: 5px;\n      .logo {\n        width: 50%;\n        float: left;\n        margin-bottom: 10px;\n        img {\n          max-width: 128px;\n        }\n      }\n      .title {\n        width: 100%;\n        float: left;\n        margin-left: 3px;\n        .centered {\n          h4 {\n            font-size: 22px;\n          }\n          h5 {\n            font-size: 14px;\n          }\n        }\n      }\n      .info {\n        position: absolute;\n        right: 10px;\n        top: 15px;\n        display: flex;\n        flex-direction: row-reverse;\n        .menu {\n          top: 93px;\n        }\n      }\n    }\n  }\n  .alert-section .header-alert{\n    font-size: .8rem;\n    .fa {\n      font-size: 1.5rem;\n      padding: 0px 0px 0px 5px;\n      line-height: 5px;\n    }\n  }\n  // filter tabs and welcome\n  .filter-tabs {\n    width: 95%;\n    margin: auto;\n    display: block;\n  }\n  .welcome {\n    margin: 20px auto;\n    width: 95%;\n    display: block;\n    h2 {\n      font-size: 32px;\n    }\n  }\n  // session row\n  .virtual-sessions-page {\n    .time-block-section {\n      p.formatted-time {\n        font-weight: 600;\n      }\n    }\n    .session {\n      display: inherit;\n      .session-cta-wrapper {\n        min-height: 115px;\n        .registration-button {\n          margin-left: 3%;\n          font-size: .75rem;\n          font-weight: 400;\n          max-width: 40%;\n          max-height: 50px;\n        }\n      }\n      .container {\n        padding: 15px 10px;\n        .action-links {\n          .add-to-calendar {\n            margin-left: none;\n          }\n          .add-to-calendar, .more {\n            float: left;\n            margin: auto;\n            font-size: 14px;\n          }\n        }\n        .session-header {\n          .session-name {\n            font-size: 20px;\n          }\n          .session-type {\n            font-size: 12px;\n          }\n        }\n      }\n      .session-icons {\n        margin: 10px 0;\n        button {\n          margin-right: auto;\n        }\n        .eblue-button {\n          font-size: .8rem;\n        }\n      }\n      &.itinerary p {\n        margin-left: 0px;\n        text-indent: 10px;\n      }\n      .session-information {\n        line-height: .75em;\n        .session-body {\n          p, li {\n            font-size: 14px;\n            line-height: 18px;\n            font-weight: 400;\n          }\n          ul > li:before {\n            margin-left: -.75em;\n          }\n        }\n      }\n    }\n    .session-timeslots{\n      grid-template-columns: unset;\n      height: auto;\n      text-align: center;\n      .timeslot-btn-div{\n        margin: 15px;\n      }\n      .add-to-calendar {\n        display: block;\n        width: 100%;\n        text-align: center;\n        margin: 15px 0;\n      }\n    }\n  }\n\n  // footer\n  footer.virtual-footer {\n  p {\n    font-size: 20px;\n  }\n  .pseudo-link {\n    cursor: pointer;\n    text-decoration: underline;\n  }\n  .copyright {\n    font-size: 10px;\n  }\n}\n\n  // closing detail modal\n  .closing-details {\n    .event-eval-btn {\n      margin-top: 10px;\n    }\n    .upcoming-event-row {\n      .container {\n        .event-image {\n          display: none;\n        }\n        grid-template-columns: inherit;\n        .register-button-container {\n          button.btn.btn-danger {\n            margin: auto;\n            margin-bottom: 10px;\n          }\n        }\n      }\n    }\n  }\n}\n\n.bad-token {\n  input {\n    width: 75%;\n    margin-bottom: 10px;\n  }\n}\n\n/* ZOOM CSS */\n#zmmtg-root {\n  display: none;\n}\n#wc-content {\n  height: calc(100% - 122px) !important;\n  bottom: -118px;\n}\n#wc-container-right {\n  height: calc(100vh - 153px) !important;\n}\n\n.ReactVirtualized__Grid.ReactVirtualized__List.chat-virtualized-list{\n  max-height: calc(100vh - 285px) !important; // need to set dynamically through browser hight - header & footer offset\n}\n.ReactVirtualized__Grid__innerScrollContainer {\n  max-height: calc(100vh - 320px) !important;\n  overflow-y: scroll !important;\n}\n.active-video-container__wrap {\n  height: calc(100vh - 200px);\n}\n\n// zoom misc.\n.audio-option-menu,\n.video-option-menu {\n  display: none !important;\n}\n.footer-button__button-label {\n  color: white;\n}\n#moreButton {\n  display: none;\n}\n.send-video-container button,\n.join-audio-container button{\n  color: #ffffff;\n}\n// timeslot styling\n.session-timeslots {\n  color: $medium-light-gray;\n  font-size: $smaller;\n  border-top: 1px dashed $medium-light-gray;\n  padding: 12px;\n  width: 100%;\n  display: grid;\n  grid-template-columns: 20% 65% 15%;\n  position: relative;\n  top: -26px;\n  background: #ffffff;\n  box-shadow: 2px 2px 8px 0px #bfbdbd;\n  height: 6rem;\n  .full-name {\n    font-weight: 900;\n    font-size: $small;\n  }\n  .btn-cancel{\n    border: 1px solid $medium-light-gray;\n  }\n  .timeslot-btn-div {\n    display: grid;\n  }\n  .timeslot-btn{\n    align-self: center;\n    padding: 5px 15px;\n    margin: 0 10px;\n    font-size: 14px;\n    &.btn-cancel {\n      border: 2px solid $solar;\n      padding: 5px 30px;\n      color: $solar;\n      &:hover{\n        border-color: $solar-secondary;\n        background-color: $solar-secondary;\n        color: #ffffff;\n      }\n    }\n    &.btn-danger {\n      color: #ffffff;\n    }\n  }\n  .add-to-calendar {\n    width: 50%;\n    font-size: 14px;\n    color: $vp-dark-gray;\n    &:hover {\n      cursor: pointer;\n      text-decoration: none;\n    }\n    .fa {\n      margin-right: 10px;\n    }\n  }\n}\n.wizard-links{\n  margin-bottom: 20px;\n  width: 100%;\n  float: left;\n  .link-divider {\n    color: $light-base;\n    font-weight: 100;\n    line-height: 5px;\n    position: relative;\n    top: -3px;\n    float: left;\n    border-left: 2px solid $light-base;\n    width: 2px;\n    height: 41px;\n    display: block;\n    margin: 0 12px;\n  }\n  .profile-nav{\n    float: left;\n    .active{\n      position: relative;\n    }\n    a:hover {\n      text-decoration: none;\n    }\n  }\n  .wizard-nav {\n    display: grid;\n    grid-template-columns: 2fr 2fr 2fr;\n    border: 2px solid $light-base;\n    border-radius: 3px;\n    float: left;\n    color: $light-base;\n    a, div {\n      text-align: center;\n      white-space: pre;\n      padding: 3px 15px;\n    }\n  }\n  a{\n    color: $medium-light-gray;\n    &.my-details {\n      border: 2px solid $light-base;\n      color: $light-base;\n      background: #ffffff;\n      padding: 3px 15px;\n      border-radius: 3px;\n      float: left;\n      &.active {\n        background-color: $light-base;\n        color: #ffffff;\n      }\n    }\n  }\n  .active{\n    background-color: $light-base;\n    color: #ffffff;\n  }\n}\n\n.wizard-form{\n  margin-top: 10px;\n  input, textarea {\n    width: 100%;\n    border: 1px $medium-light-gray solid;\n    border-radius: 3px;\n    color: $medium-dark-gray;\n  }\n  h4 {\n    color: $vp-black\n  }\n  p {\n    color: $vp-dark-gray;\n  }\n  .bottom-buttons {\n    text-align: center;\n  }\n  .rounded-circle {\n    margin-right: 5px;\n  }\n  .submit{\n    color: #ffffff;\n    background-color: $light-base;\n    width: 200px;\n    border: 2px solid $light-base;\n    &:hover {\n      background-color: #011D4B !important;\n      border-color: #011D4B !important;\n    }\n    &:disabled{\n      background-color: $light-gray;\n      background-color: $light-gray;\n      i {\n        margin-right: 10px;\n      }\n    }\n    &:focus{\n      outline: none;\n    }\n    &.previous{\n      color: $light-base;\n      background: #ffffff;\n      border: 2px solid $light-base;\n      &:hover {\n        color: #011D4B;\n        background: #E0F1FF !important;\n        border-color: #011D4B;\n      }\n    }\n  }\n  .lps {\n    width: 345px;\n  }\n  label {\n    color: $medium-light-gray;\n    font-weight: normal;\n    display: block;\n    margin-bottom: 0;\n  }\n}\n\n@media only screen and (max-width: 585px) {\n  .wizard-links .link-divider {\n    display: none;\n  }\n  .wizard-links .wizard-nav {\n    display: block;\n    margin-top: 10px;\n  }\n  .wizard-links a.my-details, .wizard-links .profile-nav {\n    float: none;\n  }\n  .wishlist-rank-page .wishlistDraggable {\n    text-align: center;\n    display: block;\n    .action-button {\n      margin-top: 5px;\n    }\n  }\n  .react-modal.error-modal, .react-modal.info-modal, .react-modal.evaluation-modal {\n    min-height: 300px;\n    .button-container button {\n      margin-top: 0px;\n    }\n  }\n}\n\n@media only screen and (max-width: 992px) {\n  .wizard-links a.my-details, .wizard-links .wizard-nav a, .wizard-links .wizard-nav div {\n    padding: 3px;\n    font-size: 12px;\n  }\n  .wizard-links .link-divider {\n    height: 36px;\n  }\n}\n\n","// Font colors\n$success-color: #38bb15;\n$warning-color: #feb52b;\n$error-color: #ff2e2e;\n$link-color: #428bca;\n\n$blue: #2d7cbf;\n$blue-light-gray: #d4e4e9;\n\n$lightest-gray: #f2f2f2;\n$light-gray: #eaeaea;\n$medium-lightest-gray: #dcdcdc;\n$medium-light-gray: #909092;\n$medium-gray: #c0c0c0;\n$medium-dark-gray: #606060;\n$dark-gray: #404040;\n\n$teal: #32c3b5;\n$gold: #f2b130;\n\n$light-base: #006AC7;\n$light-active: #264A82;\n$success-base: #00A76D;\n\n$eblack: #282829;\n$egrey: #dcddde;\n$evanta-blue: #4330ff;\n$evanta-blue-secondary: #5c4ee5;\n$gartner-blue: #002869;\n$active-slider: #3fe85c;\n$solar: #fa504b;\n$solar-secondary: #fb736f;\n$solar-tertiary: #DE0A01;\n\n\n// Font sizes\n$biggest-header: 36px;\n$big-header: 28px;\n$larger: 20px;\n$large: 16px;\n$medium: 14px;\n$small: 13px;\n$smaller: 12px;\n$tiny: 11px;\n\n// Homepage colors\n// $goldLight: #F9D889;\n// $goldPrimary: #F4B213;\n// $goldDark: #92451C;\n// $greenLight: #CDE3A5;\n// $greenPrimary: #9CC84B;\n// $greenDark: #416428;\n// $mintLight: #95E1DA;\n// $mintPrimary: #2BC4B6;\n// $mintDark: #00566B;\n// $purpleLight: #C6B1D4;\n// $purplePrimary: #8D64AA;\n// $purpleDark: #46295B;\n\n$goldLight: #F9D783;\n$goldPrimary: #92451C;\n$goldDark: #F5B51D;\n$greenLight: #C7E09A;\n$greenPrimary: #416428;\n$greenDark: #A0CA51;\n$mintLight: #8EDFD8;\n$mintPrimary: #02576C;\n$mintDark: #33C7B9;\n$purpleLight: #C3ADD2;\n$purplePrimary: #513465;\n$purpleDark: #9068AD;\n\n\n// virtual portal colors\n$vp-dark-gray: #6D6E71;\n$vp-black: #2C2C2C;\n$vp-bright-red: #FA504B;\n$vp-dark-gray-50op: rgba(109, 110, 113, 0.5)\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
